import dayjs from 'dayjs'
import { getS3UrlForAttachment } from '../../taskRefactored/tasks.slice'
import { uploadAttachmentToAWS } from '../../taskRefactored/tasks.service'

export const validateClientProfileImage = (file) => {
    if (!file) return { ok: false, reason: 'No file selected' }

    const isPng = file.type === 'image/png'
    const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg'
    const isWebp = file.type === 'image/webp'

    if (!isPng && !isJpeg && !isWebp) {
        return { ok: false, reason: 'Use a PNG, JPEG, or WebP image.' }
    }

    const maxBytes = 5 * 1024 * 1024
    if (file.size > maxBytes) {
        return { ok: false, reason: 'Image must be under 5MB.' }
    }

    return { ok: true }
}

export const uploadClientImageToS3 = async (file, dispatch) => {
    if (!file) throw new Error('No file selected')

    if (typeof window !== 'undefined' && !window.Buffer) {
        window.Buffer = require('buffer').Buffer
    }

    const ext = file.name.split('.').pop() || 'png'
    const baseName = file.name.split('.')[0] || 'client_avatar'
    const nameChange = `${baseName}_${dayjs().unix()}.${ext}`

    const presignPayload = {
        data: [
            {
                filename: nameChange,
                contentType: file.type || 'image/png',
            },
        ],
    }

    const s3Result = await dispatch(getS3UrlForAttachment(presignPayload))
    const resBody = s3Result?.payload?.data
    if (resBody?.status !== 200) {
        throw new Error(resBody?.message || 'Could not get upload URL')
    }

    const response = resBody?.data?.data
    const uploadUrl = response?.[0]?.uploadUrl
    const publicLink = response?.[0]?.publicLink

    if (!uploadUrl || !publicLink) {
        throw new Error('Upload URL missing')
    }

    const putResult = await uploadAttachmentToAWS({
        url: uploadUrl,
        data: file,
    })
    if (!putResult?.data?.ok) {
        throw new Error('Upload to storage failed')
    }

    return publicLink
}

/** Upload a bundled default avatar (webpack asset URL) to S3 for persistence */
export const uploadDefaultAvatarAssetToS3 = async (
    avatarSrc,
    avatarId,
    dispatch
) => {
    const response = await fetch(avatarSrc)
    if (!response.ok) {
        throw new Error('Could not load default avatar')
    }
    const blob = await response.blob()
    const file = new File([blob], `${avatarId || 'avatar'}.png`, {
        type: blob.type || 'image/png',
    })
    return uploadClientImageToS3(file, dispatch)
}
